module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Content_Liveshows

(function (fox, $) {
	
	fox.registerWidget('Content_Liveshows', {

		configure: function () {
			this.registerOptions('', {
				preset: 'liveshow',
				'widgets.dl': {
					widget: 'Datalayer',
					limit: 4,
					fields: ['title']
				},
				'handleWom.dlUpdated': {
					widget: '@this',
					event: 'updated',
					callback: '_dlUpdated'
				}
			});

			this.callParent('configure', arguments);
		},

		/*afterEmbed: function () {
			if (!this.dl.getCount()) {
				this.element[0].style.display = 'none';
			}
		
			this.callParent('afterEmbed', arguments);
		},*/

		activate: function () {
			this.dl.load();
		
			this.callParent('activate', arguments);
		},

		_dlUpdated: function () {
			if (!this.dl.getCount()) {
				this.element[0].style.display = 'none';
			}
		}

	}, 'Content_Browser');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/content/liveshows.js
// module id = 441
// module chunks = 4